import { render } from "./InputError.vue?vue&type=template&id=6f426a6a"
import script from "./InputError.vue?vue&type=script&lang=ts"
export * from "./InputError.vue?vue&type=script&lang=ts"
script.render = render

export default script